<template>
  <div class="home">
    <div class="body">
      <img src="@/assets/home.png" class="homeImg" />
      <div class="view">
        <div class="bodyView">
          <div class="left">
            <div class="t1">
            Llega rápidamente a la cuenta, hasta un máximo de 
              <span>S/5,000</span>
            </div>

            <div class="t2">
              Descargue la aplicación SolPrestado y finalice la sencilla solicitud para obtener un préstamo en efectivo instantáneo.
            </div>
          </div>
         
        </div>
      </div>
    </div>
    <stepComponent></stepComponent>
    <advantageView></advantageView>
    <fastView v-if="false"></fastView>
    <theMasses></theMasses>
  </div>
</template>

<script>
// import describeView from "@/components/component/describeView.vue";
import advantageView from "@/components/component/advantageView.vue";
import fastView from "@/components/component/fastView.vue";
import theMasses from "@/components/component/theMasses.vue";
import stepComponent from "@/components/component/stepComponent.vue";
export default {
  name: "HomeView",
  components: {
    // describeView,
    advantageView,
    fastView,
    theMasses,
    stepComponent
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang="scss">
@media (min-width: 680px) {
  .home {
    margin: 0 auto;

    .body {
      position: relative;
       background-color: #834FFD;
      .homeImg {
        width: 100%;
        height: 460px;
        object-fit: contain;
      }
      .view {
       
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .bodyView {
          width: 100%;
          max-width: 1080px;
          display: flex;
          align-items: self-start;
          justify-content: space-between;
          
          .left {
            width: 400px;
            padding-left: 30px;
            .t1 {
              font-weight: bold;
              font-size: 30px;
              color: #fff;
              line-height: 44px;
              text-align: left;
              span {
                color: #FFE83B;
              }
            }
            .t2 {
              margin-top: 15px;
              font-weight: 500;
              font-size: 14px;
              color: #fff;
              line-height: 21px;
              text-align: left;
            }
          }
          .rgihtImg {
            width: 400px;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 680px) {
   .home {
    margin: 0 auto;

    .body {
      position: relative;
      .homeImg {
        width: 100%;
        height: 300px;
        object-fit: cover;
      }
      .view {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .bodyView {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
   
          .left {
            width: 80%;
            margin: 0 auto;
            .t1 {
              font-weight: bold;
              font-size: 24px;
              color: #fff;
              line-height: 30px;
              text-align: center;
              span {
                 color: #FFE83B;
              }
            }
            .t2 {
              margin-top: 15px;
              font-weight: 500;
              font-size: 14px;
              color: #fff;
              line-height: 18px;
              text-align: center;
            }
          }
          .rgihtImg {
            display: none;
            width: 400px;
          }
        }
      }
    }
  }
}
</style>
